import React, { useRef } from "react";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";
import HeroSection from "./components/HeroSection";
import AboutUs from "./components/AboutUs";
import ServiceCards from "./components/ServiceCards";
import ProcessSection from "./components/ProcessSection";
import CallToAction from "./components/CallToAction";
import TestimonialsSection from "./components/TestimonialsSection";


const Homepage = () => {
  const heroRef = useRef(null);
  const footerRef = useRef(null);
  return (
    <div className="flex flex-col min-h-screen bg-background overflow-x-hidden">
      <Header variant="transparent" heroSectionRef={heroRef} footerSectionRef={footerRef} />
      <main id="main-content" className="flex-grow overflow-x-hidden">
        <HeroSection ref={heroRef} />
        <AboutUs />
        <ServiceCards />
        <ProcessSection />
        <TestimonialsSection />
        {/* <CallToAction /> */}
      </main >
      <Footer ref={footerRef} />
    </div >
  );
};

export default Homepage;